import apiRequest from '../../../shared/services/apiClient';

export interface InAppNotification {
  id: string;
  type: string;
  title: string;
  body: string;
  linkUrl: string | null;
  isRead: boolean;
  createdAtUtc: string;
}

interface InAppNotificationListResponse {
  items?: any[];
  totalCount?: number;
  unreadCount?: number;
}

const normalizeNotification = (raw: any): InAppNotification => ({
  id: String(raw?.id ?? ''),
  type: String(raw?.type ?? '').trim(),
  title: String(raw?.title ?? '').trim(),
  body: String(raw?.body ?? '').trim(),
  linkUrl: raw?.linkUrl == null ? null : String(raw.linkUrl),
  isRead: Boolean(raw?.isRead),
  createdAtUtc: String(raw?.createdAtUtc ?? new Date().toISOString()),
});

export const notificationService = {
  async list(page = 1, pageSize = 30): Promise<{ items: InAppNotification[]; totalCount: number; unreadCount: number }> {
    const payload = await apiRequest<InAppNotificationListResponse>(`/api/v1/notifications?page=${page}&pageSize=${pageSize}`);
    const items = Array.isArray(payload?.items) ? payload.items.map(normalizeNotification) : [];
    return {
      items,
      totalCount: Number(payload?.totalCount ?? items.length),
      unreadCount: Number(payload?.unreadCount ?? items.filter(n => !n.isRead).length),
    };
  },

  async getUnreadCount(): Promise<number> {
    const payload = await apiRequest<{ count?: number }>('/api/v1/notifications/unread-count');
    return Number(payload?.count ?? 0);
  },

  async markRead(notificationId: string): Promise<void> {
    await apiRequest(`/api/v1/notifications/${notificationId}/read`, {
      method: 'POST',
    });
  },

  async markAllRead(): Promise<void> {
    await apiRequest('/api/v1/notifications/read-all', {
      method: 'POST',
    });
  },
};
